/*
 * Каркас (.root/.card/.badge/.title/.hint/.actions) общий с DeathScreen
 * (widgets/death-screen/ui/DeathScreen.module.css), вынесен в ../screen-panel.module.css.
 * Здесь остаётся то, что своё у служебных страниц: чуть другой нижний паддинг карточки (нет
 * технической сводки и подвала под ней) и набор тонов бейджа — без «кида» ошибки, вместо
 * этого нейтральный/тёплый/акцентный смысловой тон.
 */

.root {
  composes: root from '../screen-panel.module.css';
}

.card {
  composes: card from '../screen-panel.module.css';
  padding: 32px 34px 34px;
}

/*
 * Цветная иконка на заливке своего тона — НЕ случай правила 2: внутри `.badge` лежит `<Icon>`,
 * а не текст (см. ScreenCard.tsx), заголовок карточки говорит то же самое словами, и иконка
 * `aria-hidden`. Разбор целиком — в widgets/death-screen/ui/DeathScreen.module.css (тот же
 * бейдж, тот же каркас `screen-panel`). Все три тона внесены в `tools/contrast.mjs` как «декор».
 */
.badge {
  composes: badge from '../screen-panel.module.css';
  background: color-mix(in oklch, var(--ink-3) 14%, var(--tint-on));
  box-shadow: inset 0 0 0 1px color-mix(in oklch, var(--ink-3) 32%, transparent);
  color: var(--ink-3);
}

.badge[data-tone='warning'] {
  background: color-mix(in oklch, var(--st-pending) 14%, var(--tint-on));
  box-shadow: inset 0 0 0 1px color-mix(in oklch, var(--st-pending) 32%, transparent);
  color: var(--st-pending);
}

.badge[data-tone='accent'] {
  background: color-mix(in oklch, var(--accent) 14%, var(--tint-on));
  box-shadow: inset 0 0 0 1px color-mix(in oklch, var(--accent) 32%, transparent);
  color: var(--accent);
}

.title {
  composes: title from '../screen-panel.module.css';
}

.hint {
  composes: hint from '../screen-panel.module.css';
}

.actions {
  composes: actions from '../screen-panel.module.css';
}
